import React, { useMemo } from "react";
import Select, { components } from "react-select";
import BankTransfersCategoryBadge from "./BankTransfersCategoryBadge";

const INCOMING_TYPE = 1;
const OUTGOING_TYPE = 2;

const BankTransfersCategorySelect = ({
    value,
    amount,
    categories,
    onChange,
    isLoading = false
}) => {
    const isMobile = window.innerWidth <= 600;

    const availableCategories = useMemo(() => {
        if (amount === 0)
            return categories;

        const type = amount > 0
            ? INCOMING_TYPE
            : OUTGOING_TYPE;

        return categories.filter(
            (category) =>
                category.id === 0 ||
                category.type === type
        );
    }, [categories, amount]);

    const groupedOptions = useMemo(() => {
        const groups = availableCategories.reduce((result, category) => {
            const groupId = category.groupId;

            if (!result[groupId]) {
                result[groupId] = {
                    groupId,
                    groupName: category.groupName,
                    options: []
                };
            }

            result[groupId].options.push({
                value: category.id,
                label: category.name,
                category
            });

            return result;
        }, {});

        return Object.values(groups).map((group) => ({
            label: group.groupName,
            options: group.options
        }));
    }, [availableCategories]);

    const selectedOption = useMemo(() => {
        const selectedCategory = categories.find(
            (category) => category.id === value
        );

        if (!selectedCategory)
            return null;

        return {
            value: selectedCategory.id,
            label: selectedCategory.name,
            category: selectedCategory
        };
    }, [categories, value]);

    const SingleValue = (props) => (
        <components.SingleValue {...props}>
            <span className="transfer-category-selected-value">
                <BankTransfersCategoryBadge category={props.data.category} />
            </span>
        </components.SingleValue>
    );

    const Option = (props) => (
        <components.Option {...props}>
            <BankTransfersCategoryBadge category={props.data.category} />
        </components.Option>
    );

    const GroupHeading = (props) => (
        <components.GroupHeading {...props}>
            <span className="transfer-category-select-group-heading">
                {props.children}
            </span>
        </components.GroupHeading>
    );

    return (
        <div
            className="transfer-category-react-select"
            onClick={(e) => e.stopPropagation()}
        >
            <Select
                options={groupedOptions}
                value={selectedOption}
                onChange={(option) => onChange(option?.value ?? 0)}
                isClearable={false}
                isSearchable
                isLoading={isLoading}
                isDisabled={isLoading}
                placeholder="Szukaj kategorii..."
                menuPortalTarget={document.body}
                menuPosition="fixed"
                menuPlacement="auto"
                components={{
                    SingleValue,
                    Option,
                    GroupHeading,
                    DropdownIndicator: () => null,
                    IndicatorSeparator: () => null
                }}
                classNamePrefix="bank-category-select"
                styles={{
                    menuPortal: (base) => ({
                        ...base,
                        zIndex: 9999,
                        ...(isMobile
                            ? {
                                  left: 12,
                                  right: 12,
                                  width: "auto"
                              }
                            : {})
                    }),

                    menu: (base) => ({
                        ...base,
                        width: isMobile ? "100%" : "430px",
                        minWidth: isMobile ? "100%" : "430px",
                        maxWidth: isMobile ? "100%" : "430px"
                    })
                }}
            />
        </div>
    );
};

export default BankTransfersCategorySelect;